export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_14.f296cdbd.jpg";